module.exports = __webpack_public_path__ + "img/eu.b7f7549.svg";